module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAeCAYAAADZ7LXbAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEfSURBVHgBzZaNjYJAEIXfUgEd3JZwHUgJ18FdB5YgV8J1cB0YK8AO1Ap2O5AOxhmJCf7A7gxi/JIXJcj7FkQHIAERlZyaE+iaHeeb4zEFLvjhHGmcwKlgQQ6kfGQhn9BC95cnRaMVfJGN6lFfMeBZwMZCI9Ff35HjhiQebyyBRhLxAkkLGxEKyRY29hrJBja2mg+D0v9Zt4ShrmLE8wsdNSzw6laZZ7HCFLigSQjWqY4iwxMT+/d4gsQn9leYAnVjN4da0yvFnrMk/dAKNDbzafhhwUojwtuVB5qHIP3yxcs97jEPnrMUiXUK5lI5OSfMS3yF5PxjjJiXViR/sE/CpIDz7y5b1D1mfqC7Iy4pe6/lg5LYK4u9yPZB3jvn2hP+bLR0+GzmNgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/person-icon.png
// module id = xoYE
// module chunks = 1